import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { DialogContent, Slide } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { Close, CloudUpload } from '@mui/icons-material';
import {
  StyledDialog,
  DialogHeaderStyled,
  StyledCloseButton,
} from '../../../utils/common/styles/commonStyles';
import MileMarkerUpload from './MileMarkerUpload';
import UploadHistoryTable from './UploadHistory';
import PropTypes from 'prop-types';

// Animations
const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Transition component for modal
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
  position: 'relative',
}));

const MileMarker = ({ open, setOpen }) => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleUploadSuccess = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleOpenUploadModal = () => {
    setOpenUploadModal(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <StyledDialog
        open={open}
        onClose={handleClose}
        slots={{ transition: Transition }}
        keepMounted
        maxWidth="lg"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: 1200,
            width: '100%',
            animation: `${slideUp} 0.4s ease-out`,
            margin: '16px',
            height: '90vh',
          },
        }}
      >
        <DialogHeaderStyled
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CloudUpload />
            Mile Markers
          </Box>
          <StyledCloseButton onClick={handleClose} size="small">
            <Close />
          </StyledCloseButton>
        </DialogHeaderStyled>

        <StyledDialogContent>
          <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Upload History Table */}
            <UploadHistoryTable
              refreshTrigger={refreshTrigger}
              onOpenUpload={handleOpenUploadModal}
            />
          </Box>
        </StyledDialogContent>
      </StyledDialog>

      {/* Upload Modal */}
      <MileMarkerUpload
        open={openUploadModal}
        setOpen={setOpenUploadModal}
        onUploadSuccess={handleUploadSuccess}
      />
    </>
  );
};

export default MileMarker;

MileMarker.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
